/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expand': {
    width: 16,
    height: 16,
    viewBox: '0 0 94 88',
    data: '<path pid="0" d="M30.048 81.807H3.307l2.929 2.93V57.995c0-1.531-1.348-3-2.93-2.93-1.594.07-2.93 1.29-2.93 2.93v26.742c0 1.582 1.336 2.93 2.93 2.93H30.048c1.531 0 3-1.348 2.93-2.93-.067-1.594-1.29-2.93-2.93-2.93zM63.952 87.666h26.741c1.582 0 2.93-1.336 2.93-2.93V57.995c0-1.532-1.348-3-2.93-2.93-1.593.07-2.93 1.289-2.93 2.93v26.741l2.93-2.93H63.952c-1.532 0-3 1.348-2.93 2.93.066 1.578 1.289 2.93 2.93 2.93zM30.048.334H3.307C1.723.334.376 1.67.376 3.264v26.741c0 1.532 1.347 3 2.93 2.93 1.593-.07 2.929-1.289 2.929-2.93V3.265l-2.93 2.93H30.048c1.531 0 3-1.348 2.93-2.93-.067-1.578-1.29-2.93-2.93-2.93zM93.62 29.997V3.255c0-1.582-1.336-2.93-2.93-2.93H63.949c-1.532 0-3 1.348-2.93 2.93.07 1.594 1.289 2.93 2.93 2.93H90.69l-2.93-2.93V29.997c0 1.531 1.348 3 2.93 2.93 1.586-.078 2.93-1.29 2.93-2.93z"/>'
  }
})
